export default "https://cdn-static.gokick.com/assets/ed6531e95fd3f911890bedfaed34e81f4e5a2128/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";